@if (isLoading()) {
  <mat-spinner></mat-spinner>
}

<app-generic-filter-selector
  [availableFilters]="availableEducationalLevelsToFilters()"
  (filterClick)="onEducationalFilterSelected($event)"
  [extraContextInfoForAccessibility]="'accessibility.educationnal_level_filter' | translate"
></app-generic-filter-selector>
